function tracks_list_callbacks() {
    $('.preview-btn').off('click').click(require('./../functions/preview_button.js'));
    $('.track-info-btn').off('click').click(require('./../functions/track_info_button.js'));
    setTimeout(require('./../functions/replace_preview_button.js'), 500);
}
tracks_list_callbacks();
